import { useEffect, useRef, useState } from "react";
import { Play, Square, Moon } from "lucide-react";
import { playMelody } from "@/lib/babySound";
import { SONGS } from "./songs";

export const SingAlong = () => {
  const [song, setSong] = useState(SONGS[0]);
  const [bed, setBed] = useState(false);
  const [line, setLine] = useState(-1);
  const player = useRef(null);
  const stop = () => { player.current?.stop(); player.current = null; setLine(-1); };
  useEffect(() => stop, []);
  const play = () => {
    stop();
    const flat = song.lines.flatMap((l, li) => l.map((x) => [...x, li]));
    const p = playMelody(flat.map(([k, b]) => [k, b]), { tempo: bed ? 0.75 : 0.45, bedtime: bed, onNote: (i) => setLine(flat[i][2]) });
    player.current = p;
    setTimeout(() => { if (player.current === p) { player.current = null; setLine(-1); } }, p.length * 1000 + 300);
  };
  return (
    <div className={`absolute inset-0 flex flex-col pt-24 px-4 sm:px-10 pb-6 transition-colors duration-700 ${bed ? "bg-[#14213A] text-[#E8E4F5]" : "bg-[#FFF8EC] text-[#2C4A3E]"}`} data-testid="game-songs">
      <div className="flex flex-wrap gap-2" data-testid="song-list">
        {SONGS.map((s) => <button key={s.id} onClick={() => { stop(); setSong(s); }} data-testid={`song-${s.id}`}
          className={`px-4 py-2 rounded-full text-sm transition-colors ${song.id === s.id ? (bed ? "bg-[#E8E4F5] text-[#14213A]" : "bg-[#2C4A3E] text-white") : bed ? "bg-white/10" : "bg-white border border-[#E6DEC3]"}`}>{s.title}</button>)}
      </div>
      <div className="mt-5 flex flex-wrap items-center gap-3">
        <button onClick={player.current ? stop : play} data-testid="song-play" className={`inline-flex items-center gap-2 px-6 py-3 rounded-full text-lg ${bed ? "bg-[#A68BE0] text-[#14213A]" : "bg-[#F28C38] text-[#3B1D05]"}`}>
          {line >= 0 ? <><Square className="w-5 h-5" />Stop</> : <><Play className="w-5 h-5" />Play</>}</button>
        <button onClick={() => { stop(); setBed(!bed); }} aria-pressed={bed} data-testid="song-bedtime" className={`inline-flex items-center gap-2 px-5 py-3 rounded-full ${bed ? "bg-white/15" : "border border-[#E6DEC3] bg-white"}`}><Moon className="w-4 h-4" />Bedtime {bed ? "on" : "off"}</button>
      </div>
      <div className="mt-6 flex-1 overflow-y-auto space-y-4" data-testid="song-lyrics">
        {song.en.map((l, i) => (
          <div key={i} className={`origin-left pl-1 transition-all duration-300 ${line === i ? "scale-[1.02] opacity-100" : line >= 0 ? "opacity-40" : "opacity-90"}`} data-testid={`song-line-${i}`}>
            <p className="font-display text-2xl sm:text-3xl">{l}</p>
            <p className={`text-lg italic ${bed ? "text-[#C9BFEA]" : "text-[#9A4F1C]"}`}>{song.es[i]}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
